import type { QuestionnaireNotificationRecipient } from './contact';

/**
 * Builds the TipTap mention markup the questionnaire editor stores for a merge field, so a
 * seeded template round-trips through the editor and `processCommunicationTemplate` exactly
 * like one an org author typed with the @-menu.
 */
function mention(tag: string) {
    return `<span class="mention" data-type="mention" data-id="${tag}" data-label="${tag}">@${tag}</span>`;
}

/**
 * Default lodgement-confirmation copy for a new questionnaire (CUR-985). Orgs edit this
 * freely in the questionnaire editor; the system never rewrites an existing questionnaire.
 * The email body and on-screen confirmation carry `@claim_link` so the driver's self-serve
 * link is delivered out of the box; the SMS keeps the same link as a bare URL.
 */
export const DEFAULT_CLAIM_LODGEMENT_CONFIRMATION = {
    notificationSendTo: ['policy_holder', 'driver'] as QuestionnaireNotificationRecipient[],
    subject: 'Your claim @claim_id has been received',
    emailBody:
        `<p>Thank you, your claim ${mention('claim_id')} has been received.</p>` +
        `<p>You can check the progress of your claim at any time here: ${mention('claim_link')}</p>`,
    smsBody: 'Your claim @claim_id has been received. Track its progress: @claim_link',
    confirmationBody:
        `<p>Thank you, your claim ${mention('claim_id')} has been received.</p>` +
        `<p>You can check the progress of your claim at any time here: ${mention('claim_link')}</p>`,
} as const;
